import { Button } from '@material-ui/core';
import GeneralTableComponent from 'components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import { RequestStatus } from 'components/GeneralFormView/types';
import { translate } from 'helperFunctions/translation';
import {
  inject,
  observer,
    useObserver,
  } from 'mobx-react';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  EventsProps,
} from '../types';
import { CellType } from 'components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import { ALLOWED_TO_ADMIN } from 'components/Layout/roles';
import { stores } from 'mobx-store';
  
  const WheelEventsScreen: React.FC<EventsProps> = observer(inject('wheelFortuneStore')((props: EventsProps) => {
    const history = useHistory();
    const {
      wheelFortuneStore,
    } = props;
    const { role } = stores.authStore.userData;
    useEffect(() => { onInit() } , []);

    const onInit = async () => {
      await wheelFortuneStore.getWheelEvents();
    }

    const addWheelEvent  = () => {
      history.push(`/wheel-fortune/events/new`);
    };
    const editWheelPress = async (index: number, key: string) => {
      const { eventId } = wheelFortuneStore.events[index];
      history.push(`/wheel-fortune/events/${eventId}/edit`);
    };

    const openPrizesTable = async (index: number, key: string) => {
      const { eventId } = wheelFortuneStore.events[index];
      history.push(`/wheel-fortune/events/${eventId}/prizes`);
    };

    const openEventsGroupsTable = () => {
      history.push(`/wheel-fortune/events-groups`);
    }

  const openWinnersTable = async (index: number) => {
    const {
      eventId,
    } = wheelFortuneStore.events[index];
    history.push(`/wheel-fortune/events/${eventId}/winners`);
  };
  
    const EventsTable = (props: {state: RequestStatus}) => {
      return(
        <GeneralTableComponent
          emptyMessage={translate('settingsListNoSettingsMessage', {
          })}
          title={'Wheel of fortune events'}
          tableHeader={[
            {
              title: "title"
            },
            {
              title: "start time"
            },
            {
              title: "end time"
            },
            {
              title: 'excepcted user numbers'
            },
            {
              title: 'early comers edge'
            },
            {
              title: "is active"
            },
            {
              title: 'Winners'
            },
            ...(ALLOWED_TO_ADMIN(role.title) ? [
              {
              title: 'Prizes'
            },
            {
              title: 'Edit'
            }
            ] : [])

          ]}
          tableData={
            wheelFortuneStore.events.map(event => {
              return {
                ...event,
                isActive: event.isActive ? 'True' : "False",
                winners: 'winners',
                prizes: 'prizes',
                edit: 'edit'
              }
            })
          }
          tableCellTypes={[
            {
             key: 'title',
             cellType: 'Text' 
            },
            {
              key: 'startTime',
              cellType: 'Text' 
            },
            {
              key: 'endTime',
              cellType: 'Text'
            },
            {
              key: 'excepctedUserNumbers',
              cellType: 'Text'
            },
            {
              key: 'earlyComersEdge',
              cellType: 'Text'
            },
            {
              key: 'isActive',
              cellType: 'Text',
            },
            {
              key: 'winners',
              cellType: 'Button',
              onClick: openWinnersTable
            },
            ...(ALLOWED_TO_ADMIN(role.title) ? [
              {
                key: 'prizes',
                cellType: 'Button' as CellType,
                onClick: openPrizesTable
              },
              {
                key: 'edit',
                cellType: 'Button' as CellType,
                onClick: editWheelPress
              }
            ] : [])
          ]}
          loadingStatus={[
            props.state
          ]}
          addButton={{
            title: 'Add Wheel event',
            onAdd: addWheelEvent
          }}
      />
      )
    };
    return useObserver(() => (
      <>
      <div style={{display: 'flex', justifyContent: 'flex-end'}}>
        <Button
          variant='contained'
          color='primary'
          onClick={openEventsGroupsTable}>
            Wheel events groups
        </Button>
      </div>
      <EventsTable state={wheelFortuneStore.status} />
      </>
    ));
  }));
  
  export default WheelEventsScreen;
  